export default {
  data() {
    return {
      bankDetails: null,
    };
  },
  created() {
    if (this.checkout.paymentOption && this.checkout.paymentOption.payment_option.id === '1' && this.paymentConfigs.bank_transfer) {
      this.bankDetails = this.paymentConfigs.bank_transfer;
    }

    this.$store.dispatch('CLEAR_CART');
  },
};